'use client';
import type { SVGProps } from 'react';
const SvgCheckboxChecked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.838 3H4.162A1.155 1.155 0 0 0 3 4.155v15.682A1.155 1.155 0 0 0 4.163 21h15.674A1.154 1.154 0 0 0 21 19.837V4.155A1.154 1.154 0 0 0 19.837 3m-2.73 5.88-5.25 7.125a.75.75 0 0 1-1.073.143l-3.75-3A.75.75 0 1 1 7.965 12l3.143 2.512 4.784-6.494a.752.752 0 0 1 1.216.885z"
    />
  </svg>
);
export default SvgCheckboxChecked;
